// removed by extract-text-webpack-plugin
module.exports = {"component":"_1Py8Xec1yrRyfGklLWRfM_","imgAndDescribe":"_2qQSge-imByETd9745jHRB","backgroundImg":"_1bNAY7pgmoSOIynae-8btb","logo":"_1FVqr9TVPbv6rT6Y41DS8B","middleImgContainer":"SlCYB9Rme_YdANdswggxT","textBox":"_1qNqaKM4R3DR03mBTwbv4V","text":"_2emTPhZd_dKirWlMHiiST7","imgAndDescribeNew":"_1PVCcAr4KyubCi48ywl3Di","shopName":"YIHJGBFZ5sVAc-oJaEMw0","backG":"_3wwmrg6ChNjVpzQ5iZVkvi","span1":"Trg0S30S7Uagj2YaT1m66","span2":"_2ZoM3LUZfd2UFhhCAs8Ls2","bottomInfo":"_1Frhf_ghc1SFdPlfuA4yUa","info":"_1GaPcpRJTf0XbtS1QHP-NE","item":"G2PAgFjLMu-8TYwCDzZ61","qrcodeImg":"_2RDxr8r4cX_2LO5wA-EpOp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ExperienceShopDetailComponent/ExperienceShopDetailComponent.scss
 ** module id = 963
 ** module chunks = 0
 **/